export default __webpack_public_path__ + "e2eb3d981bf83900825d100a6f8ca7a9.svg";